export enum LogHeaderBoardStateSources {
  CUSTOM_SELECTION_CHANGE = 'CUSTOM-SELECTION-CHANGE',
  BOARD_SELECTION_CHANGED = 'selectionChanged',
}
